module.exports = __webpack_public_path__ + "static/p1-1f82d4883bae4eb5b94cfcabf96b6d94.png";